import React from 'react';
export function AdaptacionesSection() {
  return <section className="w-full py-16 px-4 border-t border-white/10" style={{
    background: 'linear-gradient(180deg, #0a0a0a 0%, #0a1510 50%, #0a0a0a 100%)'
  }} data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-3">
          <h2 className="text-2xl sm:text-4xl font-black text-white mb-4" data-id="element-4">
            🕊️ ¿Qué agrega el{' '}
            <span className="text-[#00E68A]" data-id="element-5">
              Kit Adaptaciones al Aula Real
            </span>
            ?
          </h2>
          <p className="text-base sm:text-lg text-gray-300 max-w-3xl mx-auto" data-id="element-6">
            Ya tenés el material para el 80% del aula.{' '}
            <span className="text-[#00E68A] font-semibold" data-id="element-7">
              Adaptaciones resuelve el 20% que más tiempo te consume.
            </span>
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black/60 border border-white/10 rounded-2xl overflow-hidden mb-16" data-id="element-8">
          <div className="overflow-x-auto" data-id="element-9">
            <table className="w-full text-sm text-left" data-id="element-10">
              <thead className="border-b border-white/20" data-id="element-11">
                <tr data-id="element-12">
                  <th className="px-4 sm:px-6 py-4 font-bold text-white w-1/3" data-id="element-13">
                    Situación
                  </th>
                  <th className="px-4 sm:px-6 py-4 font-bold text-gray-400 w-1/3" data-id="element-14">
                    Sin Adaptaciones
                  </th>
                  <th className="px-4 sm:px-6 py-4 font-bold text-[#00E68A] w-1/3" data-id="element-15">
                    Con Adaptaciones
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/10" data-id="element-16">
                <tr data-id="element-17">
                  <td className="px-4 sm:px-6 py-4 text-white" data-id="element-18">
                    Un alumno no puede con el texto estándar
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-gray-400" data-id="element-19">
                    Improvisás algo "más fácil" en el momento
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-[#00E68A] font-medium" data-id="element-20">
                    Imprimís la versión BÁSICA. 30 segundos.
                  </td>
                </tr>
                <tr data-id="element-21">
                  <td className="px-4 sm:px-6 py-4 text-white" data-id="element-22">
                    Necesitás un examen diferente o la directora pide registros
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-gray-400" data-id="element-23">
                    Armás otro examen a las corridas o buscás algo que no
                    encontrás
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-[#00E68A] font-medium" data-id="element-24">
                    Abrís la evaluación diferenciada y mostrás la plantilla PPI.
                    Todo listo.
                  </td>
                </tr>
                <tr data-id="element-25">
                  <td className="px-4 sm:px-6 py-4 text-white" data-id="element-26">
                    Alumno con dislexia o que termina todo en 5 minutos
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-gray-400" data-id="element-27">
                    Dictás, simplificás o le das más de lo mismo
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-[#00E68A] font-medium" data-id="element-28">
                    Ficha de Lectura Fácil o versión EXTENDIDA. Ya están hechas.
                  </td>
                </tr>
                <tr data-id="element-29">
                  <td className="px-4 sm:px-6 py-4 text-white" data-id="element-30">
                    Grupo con niveles muy distintos en el mismo curso
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-gray-400" data-id="element-31">
                    Explicás para el promedio y perdés a todos
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-[#00E68A] font-medium" data-id="element-32">
                    Usás el Protocolo de Aula Abierta. Todos trabajan a la vez.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Kit includes heading */}
        <h3 className="text-xl sm:text-2xl font-black text-center text-white mb-8" data-id="element-33">
          ✅ EL KIT ADAPTACIONES INCLUYE:
        </h3>

        {/* Feature cards - 2 column grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-34">
          <div className="bg-[#0a1510] border border-white/10 rounded-xl p-5 border-l-4 border-l-[#00E68A]" data-id="element-35">
            <h4 className="text-[#00E68A] font-black text-base mb-2" data-id="element-36">
              Sistema de 3 Versiones por Unidad
            </h4>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-37">
              Cada unidad en 3 niveles: BÁSICA / ESTÁNDAR / EXTENDIDA. Todos
              trabajan el mismo tema. Ningún alumno queda excluido ni se aburre.
            </p>
          </div>

          <div className="bg-[#0a1510] border border-white/10 rounded-xl p-5 border-l-4 border-l-[#00E68A]" data-id="element-38">
            <h4 className="text-[#00E68A] font-black text-base mb-2" data-id="element-39">
              Fichas de Lectura Fácil + Consignas Simplificadas
            </h4>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-40">
              Textos adaptados con accesibilidad lectora y banco de consignas de
              3 niveles. Para dislexia, TDAH, bajo nivel lector o adaptar
              cualquier actividad en 5 minutos.
            </p>
          </div>

          <div className="bg-[#0a1510] border border-white/10 rounded-xl p-5 border-l-4 border-l-[#00E68A]" data-id="element-41">
            <h4 className="text-[#00E68A] font-black text-base mb-2" data-id="element-42">
              Aprendizaje Visual — Fichas Esquemáticas
            </h4>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-43">
              6 fichas 100% visuales de gramática y análisis textual. Para
              alumnos que no procesan el texto lineal pero sí el diagrama.
            </p>
          </div>

          <div className="bg-[#0a1510] border border-white/10 rounded-xl p-5 border-l-4 border-l-[#00E68A]" data-id="element-44">
            <h4 className="text-[#00E68A] font-black text-base mb-2" data-id="element-45">
              Evaluaciones Diferenciadas — Listas
            </h4>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-46">
              3 versiones por trimestre (BÁSICO / ESTÁNDAR / EXTENDIDO) con
              rúbricas diferenciadas. Nunca más armás otro examen el domingo.
            </p>
          </div>

          <div className="bg-[#0a1510] border border-white/10 rounded-xl p-5 border-l-4 border-l-[#00E68A]" data-id="element-47">
            <h4 className="text-[#00E68A] font-black text-base mb-2" data-id="element-48">
              Guía de Inclusión + Kit Legal
            </h4>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-49">
              Adaptaciones por perfil (comprensión, escritura, TDAH). Plantillas
              PPI, registros de seguimiento, informes y comunicados para
              familias. Todo con respaldo profesional.
            </p>
          </div>

          <div className="bg-[#0a1510] border border-white/10 rounded-xl p-5 border-l-4 border-l-[#00E68A]" data-id="element-50">
            <h4 className="text-[#00E68A] font-black text-base mb-2" data-id="element-51">
              Protocolo "Aula Abierta"
            </h4>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-52">
              Sistema de niveles simultáneos con cronograma de clase inclusiva
              de 40/80 min. Para grupos donde conviven niveles muy distintos en
              el mismo espacio.
            </p>
          </div>
        </div>
      </div>
    </section>;
}